import React from "react"
import { usePlacesWidget } from "react-google-autocomplete"
import CrossIcon from "../../../assets/icons/cross.svg"

const CustomGooglePlacesAutoComplete = ({
  handlePlaceSelected,
  handleClearPlace,
  geoLocation,
  className,
}) => {
  // Create a bounding box with sides ~10km away from the center point
  const defaultBounds = {
    north: geoLocation?.lat + 0.1,
    south: geoLocation?.lat - 0.1,
    east: geoLocation?.lng + 0.1,
    west: geoLocation?.lng - 0.1,
  }

  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    onPlaceSelected: handlePlaceSelected,
    options: { types: [], bounds: defaultBounds },
  })

  const handleClearClicked = () => {
    ref.current.value = ""
    handleClearPlace()
  }

  return (
    <div
      className={`h-11 border border-gray-400 rounded-full px-4 py-1 relative ${className}`}>
      <input
        ref={ref}
        placeholder="Enter City or Neighbourhood"
        className="w-full h-full border-none outline-none relative"
      />
      <img
        src={CrossIcon}
        alt=""
        className="absolute right-2 top-2 md:right-4 md:top-2.5 cursor-pointer"
        onClick={handleClearClicked}
      />
    </div>
  )
}

export default CustomGooglePlacesAutoComplete
